module.exports = __webpack_public_path__ + "img/ele3.177caeb5.png";